import { deleteLeasedEquipmentType } from "actions/Utilities/LeasedEquipmentType";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";

export default function useDeleteType() {
  const { mutate } = useMutation(
    (ids: number[]) => deleteLeasedEquipmentType(ids),
    {
      onSuccess: (res: any) => {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Type Disabled Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Type Disabled Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Disabling Type failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "Type not found":
            toast.fire("Disabling Type failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Disabling Type failed", res.Message, "error");
        }
      },
      onError: (error) => {
        toast.fire("Disabling Type failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
}
